import { getMomentTz } from "@dexteel/mesf-core";
import { ColDef } from "ag-grid-community";
import { withFraction32 } from "@/utils/fraction";

const moment = getMomentTz();

export const usePiecesTableData = () => {
	const columnDefs: ColDef[] = [
		{
			field: "Timestamp",
			headerName: "Timestamp",
			valueFormatter: (params) => {
				if (params.value) {
					return moment(params.value).format("MM/DD HH:mm:ss");
				}
				return "";
			},
			flex: 1,
			minWidth: 140,
		},
		{
			field: "ProductCode",
			headerName: "Product",
			flex: 1,
			minWidth: 90,
		},
		{
			field: "BarLength",
			headerName: "Bar Length",
			valueFormatter: (params) => withFraction32(params.value),
			flex: 1,
			minWidth: 100,
		},
		{
			field: "CycleMilliseconds",
			headerName: "Cycle (ms)",
			flex: 1,
			minWidth: 90,
		},
		{
			headerName: "Status",
			valueGetter: (params) => {
				if (params.data?.IsTooLong) return "Too Long";
				if (params.data?.IsTooShort) return "Too Short";
				return "";
			},
			flex: 1,
			minWidth: 90,
		},
		{
			headerName: "Bundle",
			valueGetter: (params) => {
				const start = params.data?.BundleStartTime;
				const end = params.data?.BundleEndTime;
				if (!start) return "";
				const s = moment(start).format("MM/DD HH:mm");
				const e = end ? moment(end).format("MM/DD HH:mm") : "...";
				return `${s} - ${e}`;
			},
			flex: 1.5,
			minWidth: 190,
		},
	];

	return { columnDefs };
};
